import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class depotsDisplayListCtrl implements IController {
  ids: any;
  isRow: any;
  rowLimit: any;
  noPickUp?: boolean;
  noDropOff?: boolean;
  onChangeFilterNoPickUp: Function;
  onChangeFilterNoDropOff: Function;
  onChange: Function;

  private depotsRef: any;
  private displayItems: any;

  /* @ngInject */
  constructor(private $depots, private $log) {
  }

  $onInit() {
    this.depotsRef = this.$depots();

    if (!this.rowLimit) {
      this.rowLimit = 10;
    }

    this.setItems(this.ids);
  }

  $onChanges(changes) {
    if (changes.ids && !changes.ids.isFirstChange()) {
      this.setItems(this.ids);
    }
  }

  onRemoveItem(id) {
    this.onChange({ids: _.filter(this.ids, (i) => {return i !== id})});
  }

  onReset() {
    this.onChange({ids: []});
  }

  private setItems(ids) {
    if (ids && ids.length) {
      this.depotsRef.$asyncValues(ids)
        .then((depots) => {
          const displayItems = [];
          _.forEach(depots, (d) => {
            displayItems.push({id: d.id, value: d.name})
          })
          this.displayItems = displayItems;
        })
        .catch((error) => {
          this.$log.error('Failed to get branches', error);
        })
    } else {
      this.displayItems = [];
    }
  }



}

angular
  .module('bringoz.admin.depots')
  .component('depotsDisplayList', {
    bindings: {
      ids: '<',
      isRow: '<?',
      rowLimit: '<?',
      noPickUp: '<?',
      noDropOff: '<?',
      onChangeFilterNoPickUp: '&',
      onChangeFilterNoDropOff: '&',
      onChange: '&'
    },
    template: require('./depots-display-list.html').default,
    controller: depotsDisplayListCtrl
  });
